import * as React from 'react';
import { Controller, MainMenu, Menu, Toolbar, UseBefore } from '@tencent/workbench';
import { EXPORT_PDF_CONFIG, MENU_CONFIGS, PDF_TO_EXCEL_CONFIG, PDF_TO_PPT_CONFIG, PDF_TO_WORD_CONFIG, TOOLBAR_ITEMS, config } from './config';
import { wrapIdForBig } from '../../util/wrap-id-util';
import { ExportFileFeature } from '../export-file/export-file-feature';
import { ExportNoPermissionMiddleware } from '../../middleware/export-no-permission-tooltip';
import { ConversionType, PdfTransformFeature } from './pdf-transform-feature';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { getOwnerVipLevel } from '../titlebar/api';
import { VipType } from '@src/js/common/ark-extensions/dc-components/avatar-nick-nameplate/type';
import { TDWActionType, TDWModuleType, TDWOperationType, TDWVer5Type, TDWVer6Type, TDWVer11Type } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class PdfTransformController {
    public constructor(
        private readonly exportFileFeature: ExportFileFeature,
        private readonly pdfTransformFeature: PdfTransformFeature,
    ) {
    }

    @Toolbar(config.id, 'dropdownContent')
    @Toolbar(wrapIdForBig(config.id), 'dropdownContent')
    public getPcBtnDropdownContent() {
        this.report({
            opername: TDWOperationType.DOC_VIP_ALLFUNC,
            module: TDWModuleType.ENTRANCE,
            action: TDWActionType.MENU_BAR_CLICK,
            ver6: TDWVer6Type.PDF,
            ver11: TDWVer11Type.PC_SLIDETOOLBAR,
        });
        return <MainMenu align="left" name={config.id} mode="menu"/>;
    }

    @Toolbar(config.id, 'onDropdownVisibleChange')
    @Toolbar(wrapIdForBig(config.id), 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.pdfTransformFeature.updateDropdownVisible(visible, config.id);
    }

    @Menu(EXPORT_PDF_CONFIG.name, 'onClick')
    public exportPDF() {
        this.report({
            opername: TDWOperationType.DOC_VIP_ALLFUNC,
            module: TDWModuleType.TOPDF,
            action: TDWActionType.MENU_BAR_CLICK,
            ver6: TDWVer6Type.SLIDE2PDF,
        });
        this.exportFileFeature.exportPDF(false);
    }

    @Menu(EXPORT_PDF_CONFIG.name, 'shouldHide')
    public exportPDFShouldHide() {
        return ENV.IS_PC_LOCAL_EDIT;
    }

    @Menu(EXPORT_PDF_CONFIG.name, 'tooltip')
    @UseBefore(ExportNoPermissionMiddleware)
    public authHoverTips() {
        return EXPORT_PDF_CONFIG.tooltip as string;
    }

    @Menu(PDF_TO_WORD_CONFIG.name, 'onClick')
    public pdfToWord() {
        this.pdfTransformFeature.pdfToOffice(ConversionType.PDF_TO_WORD);
    }

    @Menu(PDF_TO_EXCEL_CONFIG.name, 'onClick')
    public pdfToExcel() {
        this.pdfTransformFeature.pdfToOffice(ConversionType.PDF_TO_EXCEL);
    }

    @Menu(PDF_TO_PPT_CONFIG.name, 'onClick')
    public pdfToPPT() {
        this.pdfTransformFeature.pdfToOffice(ConversionType.PDF_TO_PPT);
    }

    @Toolbar(config.id, 'shouldDisabled')
    @Toolbar(wrapIdForBig(config.id), 'shouldDisabled')
    @Toolbar(`${ActionType.PDF_TRANSFORM}-parent`, 'shouldDisabled')
    @Toolbar(wrapIdForBig(`${ActionType.PDF_TRANSFORM}-parent`), 'shouldDisabled')
    public shouldDisabled() {
        return this.pdfTransformFeature.shouldDisabled(config.id);
    }

    @Toolbar(config.id, 'shouldHide')
    @Toolbar(wrapIdForBig(config.id), 'shouldHide')
    @Toolbar(`${ActionType.PDF_TRANSFORM}-parent`, 'shouldHide')
    @Toolbar(wrapIdForBig(`${ActionType.PDF_TRANSFORM}-parent`), 'shouldHide')
    public shouldHide() {
        return !(appConfigInstance.getConfig(ToolbarFileMenuConfig.convertToPDF as any) ?? true);
    }

    private report = (params) => {
        getOwnerVipLevel(window.clientVars?.padId).then(({ vipLevel }) => {
            const ver5Value = {
                [VipType.NORMAL]: TDWVer5Type.VIP_USER,
                [VipType.SUPER]: TDWVer5Type.SVIP_USER,
                [VipType.NONE]: TDWVer5Type.NOVIP_USER,
                [VipType.SUPER_PLUS]: TDWVer5Type.SVIP_PLUS,
            };
            tdw({
                ver5: ver5Value[vipLevel] ?? TDWVer5Type.NOVIP_USER,
                ...params,
            });
        });
    };
}
